import { useParams } from 'react-router-dom'

import { useGetUserByIdQuery } from '@/services/tenant/users'
import { getMediaUrl } from '@/utils/helpers'

const UserPage = () => {
    const { id } = useParams()

    const { data, isLoading } = useGetUserByIdQuery(id || 0, {
        skip: !id,
    })
    const user = data?.data

    if (isLoading || !user) return null
    return (
        <main className="content flex flex-col">
            <div className="px-container flex flex-col flex-auto">
                <div className="card-user-info mb-18">
                    <div className="card-user-info__item flex items-center gap-18">
                        <div className="user-photo-60x60">
                            <img
                                src={getMediaUrl(user?.photo)}
                                alt="user"
                            />
                        </div>

                        <div className="flex flex-col">
                            <h5 className="mb-4px">{user?.fullName}</h5>
                            <span className="text--xs text-color-1">
                                {user?.email}
                            </span>
                            <span className="text--xs text-color-1">
                                {user?.phone}
                            </span>
                        </div>
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-10">Roles</h2>
                        {user?.roles.map(role => (
                            <span className="text--xs text-color-1">
                                {role}
                            </span>
                        ))}
                    </div>
                    <div className="card-user-info__item flex flex-col items-center">
                        <h2 className="mb-10">Status</h2>
                        <span className="text--xs text-color-1">
                            {user?.status}
                        </span>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default UserPage
